// Selection of the data shown in the Panel Klienta "Kontakt" tab.
//
// Historically the displayed company contact data was chosen purely by domain +
// locale. For the Polish (Euro-Tax.pl) context we now refine the CUF vs ETX choice
// by the client's actual cases: a client whose cases are ALL handled by CUF
// ("obsługiwane przez" = CUF) sees CUF contact data, while a client with a mix of
// CUF and Euro-Tax.pl cases keeps the ETX data. Other companies (RO/BG) are
// unchanged.
//
// Plain CommonJS (no build-time deps) so the pure logic can be unit-tested with
// node's built-in assert; webpack imports the named exports as usual.

// Company name ("obsługiwane przez", i.e. Company#name) treated as CUF. Per the
// task scope only "CUF Sp. z o.o." counts; the legacy "CUF/euro-tax.pl" alias does NOT.
const CUF_COMPANY_NAMES = ['cuf sp. z o.o.']

const CONTACT_DETAILS = {
  ro: {
    name: 'EURO-TAX.RO SERVICII FISCALE EMIGRANTI S.R.L.',
    street: 'Str. Drumul Gării Odăi, Nr. 1A, Et.2 Clădirea Airport Plaza intrarea A, Otopeni, Jud. Ilfov Cod poștal: 719182',
    email: 'suportclienti@euro-tax.ro',
    helpline: '031 780 90 94',
    www: 'euro-tax.ro'
  },
  bg: {
    name: 'Euro-tax.bg',
    street: '1797 София, ж.к. Младост 1, бул. „Климент Охридски“ 1А – етаж 3',
    email: 'dok@euro-tax.bg',
    helpline: '+359 24 23 59 59',
    www: 'euro-tax.bg'
  },
  etx: {
    name: 'Euro-Tax.pl Zwrot Podatku S.A.',
    street: 'ul. Sikorskiego 26, 53-659 Wrocław',
    email: 'bok@euro-tax.pl',
    helpline: '71 799 0 600',
    www: 'euro-tax.pl'
  },
  cuf: {
    name: 'CUF Sp. z o.o.',
    street: 'ul. Szelągowska 25/2-3, 61-626 Poznań, Polska',
    email: 'bok@cuf.com.pl',
    helpline: '+48 61 828 81 02',
    www: 'cuf-podatki.pl'
  }
}

function normalizeCompanyName (name) {
  return typeof name === 'string' ? name.trim().toLowerCase().replace(/\s+/g, ' ') : ''
}

function isCufCompany (name) {
  return CUF_COMPANY_NAMES.includes(normalizeCompanyName(name))
}

// True only when the client has at least one case and EVERY case is handled by CUF.
function hasOnlyCufCases (documents) {
  if (!Array.isArray(documents) || documents.length === 0) return false

  return documents.every(document => !!document && isCufCompany(document.company))
}

function resolveContactKey ({ locale, host = '', documents = [] } = {}) {
  if (locale === 'ro' || host.includes('.ro')) return 'ro'
  if (locale === 'bg' || host.includes('.bg')) return 'bg'
  if (locale === 'pl' || host.includes('.euro-tax.pl')) {
    return hasOnlyCufCases(documents) ? 'cuf' : 'etx'
  }

  return 'cuf'
}

function resolveContactDetails (params) {
  return CONTACT_DETAILS[resolveContactKey(params)]
}

function capitalGroupInfo (host = '') {
  return host.includes('.pl') ? 'Spółka należy do Grupy Kapitałowej Euro-Tax.pl S.A.' : ''
}

module.exports = {
  CUF_COMPANY_NAMES,
  CONTACT_DETAILS,
  isCufCompany,
  hasOnlyCufCases,
  resolveContactKey,
  resolveContactDetails,
  capitalGroupInfo
}
